import OriginTypography from './Typography';
import Text from './Text';
import Title from './Title';
import Paragraph from './Paragraph';
var Typography = OriginTypography;
Typography.Text = Text;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
export default Typography;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/typography/index.js
// module id = 860
// module chunks = 0